<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <ValidationProvider
            rules="required"
            vid="name"
            :name="$t('fields.name').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.name"
            :counter="30"
            :label="$t('fields.name')"
            :error-messages="errors"
          ></v-text-field>

          <v-select
            v-model=" form.is_default"
            :items="defaultItems"
            item-text="label"
            item-value="value"
            :label="$t('fields.default')"
            :error-messages="errors"
          ></v-select>

        </ValidationProvider>
    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import { warehousesService } from '../../../utils/services/warehouses.service';

  export default {
    name: 'WarehouseModal',
    data() {
      return {
        stored: null,
        warehouse: {},
        defaultItems: [{ value: 1, label: this.$t('fields.true') }, { value: 0, label: this.$t('fields.false') }],
        form: {
          name: null,
          is_default: null,
        },
        loading: false,
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },
      fetchWarehouse(id) {
        return warehousesService.get(id)
        .then(response => {
            this.warehouse = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
    },
    async created() {
      this.loadingModal(true);
      if (this.data.stored.id) {
        await this.fetchWarehouse(this.data.stored.id);
        this.form = {
          id: this.data.stored.id,
          name: this.warehouse.name,
          is_default: this.warehouse.is_default,
        };
      }
      this.loadingModal(false);
    },
  };
</script>
